//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import Swiper from 'swiper'
import ActiveClass from '../../assets/js/swiper/active-class'

import IconArrowLeft from '../../assets/svg/arrow-left.svg?inline'
import IconArrowRight from '../../assets/svg/arrow-right.svg?inline'
import hasVideos from '~/mixins/hasVideos'

Swiper.use([ActiveClass])

export default {
  components: { IconArrowLeft, IconArrowRight },
  mixins: [hasVideos],

  data() {
    return { isBeginning: true, isEnd: false, lastMeta: null }
  },

  watch: {
    videos() {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.update()
        } else {
          this.initSwiper()
        }
      })
    },
  },

  beforeMount() {
    this.loadMoreVideos()
  },

  mounted() {
    this.initSwiper()
  },

  beforeDestroy() {
    this.swiper && this.swiper.destroy()
  },

  methods: {
    get,
    initSwiper() {
      const sync = () => {
        this.isBeginning = this.swiper.isBeginning
        this.isEnd = this.swiper.isEnd
      }
      const handleUpdate = (swiper) => {
        // Adjust grid to be like all slides have same width.
        // Changing the width when slide is active causes Swiper to miscalculate the grid.
        swiper.snapGrid = swiper.snapGrid.map((_, i) => {
          // Regular slide width.
          const w = 308 + 8 * 2
          return i * w
        })

        sync()
      }
      const handleTransitionStart = (swiper) => {
        // Set fixed height to prevent layout change.
        swiper.el.style.height = `${swiper.el.offsetHeight}px`

        sync()
        this.resetVideos()
      }
      const handleTransitionEnd = (swiper) => {
        swiper.el.style.height = ''
        if (swiper.activeIndex >= this.videos.length - 5) this.loadMoreVideos()
      }

      this.swiper = new Swiper(this.$el.querySelector('.swiper-container'), {
        resistanceRatio: 0,
        slidesPerView: 'auto',
        on: {
          click: (swiper) => swiper.slideTo(swiper.clickedIndex),
          // After Swiper updated.
          // https://github.com/nolimits4web/swiper/blob/4083ab9164c321836cd89fca2e7093fe2a9159a9/src/components/core/core-class.js#L372
          update: handleUpdate,
          resize: handleUpdate,
          transitionStart: handleTransitionStart,
          transitionEnd: handleTransitionEnd,
        },
      })
    },

    async waitToPlay() {
      if (this.swiper.animating) {
        await new Promise((resolve) =>
          this.swiper.once('transitionEnd', resolve)
        )
      }
    },

    resetVideos() {
      this.$refs.videoItems.forEach((video) => video.reset())
    },
  },
}
